import React from "react";
import { NavBar } from "./Styled";
import VerticalNavigation from "./VerticalNavigation";
import MainBar from "./MainBar";
import ProfileName from "./ProfileName";
import ProfileMenu from "./ProfileMenu";

const NavigationBar = ({ setIsCollapsed }: { setIsCollapsed: Function }) => {
 
    return (
        <NavBar>
            <VerticalNavigation setIsCollapsed={setIsCollapsed} />
            <MainBar />
            {/* <Notification /> */}
            <ProfileName />
            <ProfileMenu />
        </NavBar>
    );
};

export default NavigationBar;
